/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import { transformRequestOptions } from "utils/queryString";
import api from "_config/api";

interface ObterDoencaResponse {
  value: number;
  name: string;
}

interface State {
  isRequesting: boolean;
  successPayload: ObterDoencaResponse[];
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: [],
  errors: []
};

const obterDoencasSlice = createSlice({
  name: "zoonose@obterDoencas",
  initialState,
  reducers: {
    obterDoencas: (state): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterDoencasSuccess: (
      state,
      action: PayloadAction<ObterDoencaResponse[]>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterDoencasFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction() {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/saude/listar-doenca-preexistente`
    );

    const { data } = response;

    yield put(obterDoencasSuccess(data));
  } catch (error) {
    yield put(obterDoencasFailed(formatError(error)));
  }
}

export const { obterDoencas, obterDoencasSuccess, obterDoencasFailed } =
  obterDoencasSlice.actions;

export const { reducer } = obterDoencasSlice;

export const saga = takeLatest(obterDoencas.type, sagaFunction);
